import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription, map, of } from 'rxjs';

import { INetworkSideNavConfigOptions } from 'Src/nvps-libraries/design/nv-sidebar-list/nv-sidebar.interface';
import { IPageBannerMeta } from 'Src/ng2/shared/components/page-banner/page-banner.interface';
import { PORTAL_TYPES } from 'Src/ng2/shared/typings/interfaces/portal.interface';
import { NETWORK_ATT_CAL_ACTIONS, NETWORK_ATT_CAL_ACTIONS_DICT } from 'Src/ng2/shared/services/mixpanel/event-interfaces/network-att-cal-actions';

import { PageBannerService } from 'Src/ng2/shared/components/page-banner/page-banner.service';
import { EventFormatterService } from 'Src/ng2/shared/services/mixpanel/event-formatter.service';
import { MixpanelService } from 'Src/ng2/shared/services/mixpanel/mixpanel.service';

@Component({
  selector: 'network-tab-layout',
  templateUrl: './network-tab-layout.component.html',
  styleUrls: ['./network-tab-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})

export class NetworkTabLayoutComponent implements OnInit, OnDestroy {
  public isInMaintenanceMode: boolean = false;
  public sideNavOptions: INetworkSideNavConfigOptions;
  private pageBannerMeta$: Subscription;
  public pageBannerMeta: IPageBannerMeta;

  public activeTab: string = '';
  public navigationTabs$: Observable<any>;
  public showSubNav$: Observable<boolean> = of(true);
  private subNavConfig$: Observable<
    {
      tabs: any[];
      showWarningMessage?: boolean;
      warningMessage?: string;
      warningTooltip?: string;
    }
  >;

  constructor (
    private route: ActivatedRoute,
    private pageBannerService: PageBannerService,
    private eventFormatterService: EventFormatterService,
    private mixpanelService: MixpanelService,
  ) { }

  ngOnInit () {
    this.isInMaintenanceMode = this.route.snapshot.data.maintenanceMode;
    this.pageBannerMeta$ = this.pageBannerService.getPageBannerMeta().subscribe((data) => {
      this.pageBannerMeta = data;
    });
    this.sideNavOptions = this.route.snapshot.data.networkSideNavConfig;
    this.subNavConfig$ = this.pageBannerService.getSubNavConfig();
    this.navigationTabs$ = this.subNavConfig$.pipe(map(config => config.tabs));
  }

  ngOnDestroy (): void {
    this.pageBannerMeta$.unsubscribe();
  }

  onTabClick (tab: string): void {
    const prevTab = this.activeTab;
    const nextTab = tab;
    this.trackEvent(prevTab, nextTab);
    this.activeTab = tab;
  }

  private trackEvent (prevTab: string, nextTab: string) {
    let event = '';
    if (prevTab !== nextTab && nextTab === 'day-view') {
      event = NETWORK_ATT_CAL_ACTIONS.DAY_TOGGLE;
    } else if (prevTab !== nextTab && nextTab === 'month-view') {
      event = NETWORK_ATT_CAL_ACTIONS.MONTH_TOGGLE;
    } else {
      return;
    }
    const formattedEvent = this.eventFormatterService.getNetworkAttendanceCalendarPageActionEvent({
      portal: PORTAL_TYPES.NETWORK,
      action: NETWORK_ATT_CAL_ACTIONS_DICT[event.toLowerCase()] || event,
      page: prevTab,
    });
    this.mixpanelService.trackEvents([formattedEvent]);
  }
}
